import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → MoneyMind: the usage dashboard and the employee list.
 *
 * MoneyMind is a reflection exercise about spending, so this section reports
 * take-up and the keep / unsure / let-go mix and nothing financial. No amount,
 * no currency total, no income and no savings appear anywhere in it, at company
 * level or per person.
 */
const CompanyMoneyMindLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'MoneyMind Dashboard',
      path: `/${slug}/moneymind`,
      description: 'Take-up, how regularly people log, and how they sort what they spend on'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/moneymind/users`,
      description: `Per-${population.replace(/s$/, '')} usage — never amounts`
    }
  ];

  return (
    <CompanySectionLayout
      title="MoneyMind"
      subtitle={`How many of your ${population} use MoneyMind and how regularly. Nothing on these pages is a sum of money.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyMoneyMindLayout;
